module.exports = __webpack_public_path__ + "img/指定办理人数.d8f0bee3.svg";